"use client";

import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import { useBreakpoints } from "@/hooks/useBreakpoints/useBreakpoints";
import { useState } from "react";
import { StickyLozengeModel } from "./StickyLozenge.model";

const StickyLozenge = ({
  icon,
  buttonText,
  handleClick,
}: StickyLozengeModel) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isMobile } = useBreakpoints();
  const handleClickLozenge = () => {
    if (handleClick) {
      if (isMobile) {
        setIsHovered(!isHovered);
        if (isHovered) {
          handleClick();
        }
      } else {
        handleClick();
      }
    }
  };
  return (
    <div className="lozenge bottom-xxl right-lg max-md:right-sm fixed z-10">
      <div
        className="group text-core-white bg-dark-tints-dark-slate hover:bg-core-red focus:bg-core-red hover:rounded-6 focus:rounded-6 hover:rounded-btn focus:rounded-btn relative h-12 w-12 rounded-[50%] transition-all duration-300 ease-[cubic-bezier(0.47,1.64,0.41,0.8)] outline-none hover:flex hover:w-[196px] focus:flex focus:w-[196px]"
        tabIndex={0}
        role="button"
        onClick={handleClickLozenge}
        onKeyDown={event => {
          if (event.key === "Enter" && handleClick) {
            handleClick();
          }
        }}
      >
        <Typography.LLABEL1 className="hidden w-full items-center justify-start pl-[30px] uppercase group-hover:flex group-focus:flex">
          {buttonText}
        </Typography.LLABEL1>
        <Image
          id="sticky-icon"
          src={icon}
          alt="sticky-icon"
          width={32}
          height={32}
          hasPlaceholder
          className="absolute top-1/2 right-2 -translate-y-1/2 transform"
        />
      </div>
    </div>
  );
};

export default StickyLozenge;
